// API Configuration - reads from environment variables
// For Cloudflare Pages, set these in Settings > Environment Variables
// For Create React App, use REACT_APP_ prefix

// API Key for backend requests
export const API_KEY = process.env.REACT_APP_API_KEY || '';

// Allowed usernames (comma-separated in env variable)
// Example: REACT_APP_ALLOWED_USERNAMES=bekcom,masterzobs,newusers
const allowedUsernamesEnv = process.env.REACT_APP_ALLOWED_USERNAMES || '';
export const ALLOWED_USERNAMES: string[] = allowedUsernamesEnv
  ? allowedUsernamesEnv.split(',').map((u: string) => u.trim().toLowerCase())
  : [];

// API Base URL (prod). We only run against prod — api.tez.is fronts the dev
// cluster, whose Redis is a separate logical DB, so anything saved through it
// (e.g. live milestone badges) is invisible to the prod ws workers that read it.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.tezda.tech';

// Banner API Base URL (uses wss.tez.is)
export const BANNER_API_BASE_URL = process.env.REACT_APP_BANNER_API_BASE_URL || 'https://wss.tez.is';

// Live API Base URL
export const LIVE_API_BASE_URL = process.env.REACT_APP_LIVE_API_BASE_URL || 'https://live.tezda.tech';

// Marketing API Base URL (announcement management)
export const MARKETING_API_BASE_URL = process.env.REACT_APP_MARKETING_API_BASE_URL || 'https://mark.tezda.tech';

// Marketing API Key (set REACT_APP_MARKETING_API_KEY in Cloudflare Pages env)
export const MARKETING_API_KEY = process.env.REACT_APP_MARKETING_API_KEY || '';

export const getMarketingApiHeaders = () => ({
  'Content-Type': 'application/json',
  'x-api-key': MARKETING_API_KEY,
});

// Common headers for API requests
export const getApiHeaders = (authToken?: string) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY,
  };

  if (authToken) {
    headers['Authorization'] = authToken;
  }

  return headers;
};
